// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + ({"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred","500":"page-unavailableProduct"}[chunkId] || chunkId) + "." + {"189":"f38c8172cee2ff70b113","357":"021a0e7430d32bfa3257","404":"cde649208c9e4a454fd9","406":"07d8fcfc800c40a8bba3","500":"3995cdf701ada7f4a611"}[chunkId] + ".css";
};